import Documents from '../../../../store/documents/main';

angular
    .module('festzelt-os.contacts')
    .factory('Documents', [
        '$injector',
        'Document',
        ($injector, Document) => new Documents(Document, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/documents/main/store/document.js